import React, { useState, useCallback, useEffect, useRef } from 'react'
import {
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Slider,
  Checkbox,
  FormControlLabel,
  Pagination,
  Autocomplete,
  TextField,
  InputAdornment,
} from '@mui/material'
import useStyles from './style'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { numberToIndianRupee } from 'utils/numberToIndianRupee'
import { useUrlSearchParams } from 'utils/hooks'
import productsApi from 'services/products'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import _ from 'lodash'
import { API_ENDPOINTS } from 'constants'
import { useNavigate } from 'react-router-dom'
import SearchIcon from '@mui/icons-material/Search'

const metalPrice = {
  gold: 5535,
  diamond: 10997,
  silver: 775,
  platinum: 23573,
}

const products = [
  {
    // General details
    id: 1,
    name: 'Sparkle Multi Stone Gold Earrings',
    img: '/assets/images/products/earrings.webp',
    mainCategory: 'gold',
    subCategory: 'earrings',
    ocassion: 'casual',
    gender: 'female',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 10,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 10,
    gstFinalValue: 780,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 2,
    name: 'Multi Stone Gold Bangles',
    img: '/assets/images/products/bangles.webp',
    mainCategory: 'gold',
    subCategory: 'bangles',
    ocassion: 'party',
    gender: 'female',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 3,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 3,
    name: 'Geometric Diamond Bracelet',
    img: '/assets/images/products/bracelets.webp',
    mainCategory: 'diamond',
    subCategory: 'bracelets',
    ocassion: 'party',
    gender: 'unisex',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 5,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 4,
    name: '22KT Gold 2 Grams Leaf Coin',
    img: '/assets/images/products/coin.webp',
    mainCategory: 'gold',
    subCategory: 'coins',
    ocassion: 'casual',
    gender: 'unisex',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 5,
    name: 'Dainty Floral Mangalsutra',
    img: '/assets/images/products/mangalsutras.webp',
    mainCategory: 'diamond',
    subCategory: 'mangalsutra',
    ocassion: 'casual',
    gender: 'unisex',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 6,
    name: 'Twilight Dream Necklace',
    img: '/assets/images/products/necklace.webp',
    mainCategory: 'diamond',
    subCategory: 'necklace',
    ocassion: 'casual',
    gender: 'female',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 15,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 7,
    name: 'Elaborate 22 Karat Yellow Gold Floral Nath',
    img: '/assets/images/products/nosepins.webp',
    mainCategory: 'silver',
    subCategory: 'nosepins',
    ocassion: 'casual',
    gender: 'female',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 8,
    name: 'Beauty Color Stone Floral Gold Pendants',
    img: '/assets/images/products/pendant.webp',
    mainCategory: 'silver',
    subCategory: 'pendant',
    ocassion: 'casual',
    gender: 'female',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 7,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
  {
    // General details
    id: 9,
    name: 'Gorgeous Floral Gold Rings',
    img: '/assets/images/products/weddingring.webp',
    mainCategory: 'platinum',
    subCategory: 'weddingring',
    ocassion: 'traditional',
    gender: 'unisex',
    // Gold details
    metalMrp: 33987,
    metalSellingPrice: 45009,
    metalPurity: 91.6,
    metalWeight: 3.944,
    metalDiscount: 0,
    metalFinalValue: 33987,
    // Stone details
    stoneMrp: 33987,
    stoneSellingPrice: 45009,
    stoneCount: 901,
    stoneWeight: 1.24,
    stoneDiscount: 0,
    stoneFinalValue: 33987,
    // Making charges
    makingCharge: 3839,
    makingDiscount: 768,
    makingFinalValue: 3071,
    // Wastage charges
    wastageCharge: 3987,
    wastageDiscount: 110,
    wastageWeight: 0.144,
    wastageFinalValue: 3987,
    // Total
    totalValue: 26331,
    totalDiscount: 768,
    totalFinalValue: 25563,
    // Gst
    gstPercentage: 3,
    gstValue: 790,
    gstDiscount: 0,
    gstFinalValue: 790,
    // Grand total
    grandTotalValue: 27121,
    grandTotalDiscount: 100,
    grandFinalValue: 27021,
  },
]

const categoryFilter = [
  { id: 1, name: 'Gold' },
  { id: 2, name: 'Diamond' },
  { id: 3, name: 'Silver' },
  { id: 4, name: 'Platinum' },
]

const ocassionFilter = [
  { id: 1, name: 'Casual wear', checked: false },
  { id: 2, name: 'Traditional wear', checked: false },
  { id: 3, name: 'Party wear', checked: false },
  { id: 4, name: 'Everyday wear', checked: false },
  { id: 5, name: 'Office wear', checked: false },
]

const purityFilter = [
  { id: 1, name: '96.6', value: 96.6, checked: false },
  { id: 2, name: '95', value: 95, checked: false },
  { id: 3, name: '18 kt', value: 18, checked: false },
  { id: 4, name: '22 k', value: 22, checked: false },
]

const weightRangeFilter = [
  { id: 1, name: '0-2grams', value: 96.6, checked: false },
  { id: 2, name: '2-5grams', value: 95, checked: false },
  { id: 3, name: '5-10grams', value: 18, checked: false },
  { id: 4, name: '10-20grams', value: 22, checked: false },
  { id: 5, name: '>20grams', value: 22, checked: false },
]

const genderFilter = [
  { id: 1, name: 'Female', value: 'female', checked: false },
  { id: 2, name: 'Male', value: 'male', checked: false },
  { id: 3, name: 'Unisex', value: 'unisex', checked: false },
  { id: 4, name: 'Kids & Teens', value: 'adult', checked: false },
]

const searchOptionsList = [
  { label: 'Earrings', value: 'gold' },
  { label: 'Necklaces', value: 'diamond' },
  { label: 'Gold coins', value: 'platinum' },
  { label: 'Marrage rings', value: 'silver' },
]

export const weightRangeOptionsData = [
  {
    _id: 1,
    name: '0-2grams',
    options: [
      { name: '0.5g', value: 0.5 },
      { name: '1g', value: 1 },
      { name: '1.5g', value: 1.5 },
      { name: '2g', value: 2 },
    ],
    checked: false,
  },
  {
    _id: 2,
    name: '2-5grams',
    options: [
      { name: '2.5g', value: 2.5 },
      { name: '3g', value: 3 },
      { name: '3.5g', value: 3.5 },
      { name: '4g', value: 4 },
      { name: '4.5g', value: 4.5 },
      { name: '5g', value: 5 },
    ],
    checked: false,
  },
  {
    _id: 3,
    name: '5-10grams',
    options: [
      { name: '5.5g', value: 5.5 },
      { name: '6g', value: 6 },
      { name: '6.5g', value: 6.5 },
      { name: '7g', value: 7 },
      { name: '7.5g', value: 7.5 },
      { name: '8g', value: 8 },
      { name: '8.5g', value: 8.5 },
      { name: '9g', value: 9 },
      { name: '9.5g', value: 9.5 },
      { name: '10g', value: 10 },
    ],
    checked: false,
  },
  {
    _id: 4,
    name: '10-15grams',
    options: [
      { name: '10.5g', value: 10.5 },
      { name: '11g', value: 11 },
      { name: '11.5g', value: 11.5 },
      { name: '12g', value: 12 },
      { name: '12.5g', value: 12.5 },
      { name: '13g', value: 13 },
      { name: '13.5g', value: 13.5 },
      { name: '14g', value: 14 },
      { name: '14.5g', value: 14.5 },
      { name: '15g', value: 15 },
    ],
    checked: false,
  },
  {
    _id: 5,
    name: '15-20grams',
    options: [
      { name: '15.5g', value: 15.5 },
      { name: '16g', value: 16 },
      { name: '16.5g', value: 16.5 },
      { name: '17g', value: 17 },
      { name: '17.5g', value: 17.5 },
      { name: '18g', value: 18 },
      { name: '18.5g', value: 18.5 },
      { name: '19g', value: 19 },
      { name: '19.5g', value: 19.5 },
      { name: '20g', value: 20 },
    ],
    checked: false,
  },
  {
    _id: 6,
    name: '20-25grams',
    options: [
      { name: '20.5g', value: 20.5 },
      { name: '21g', value: 21 },
      { name: '21.5g', value: 21.5 },
      { name: '22g', value: 22 },
      { name: '22.5g', value: 22.5 },
      { name: '23g', value: 23 },
      { name: '23.5g', value: 23.5 },
      { name: '24g', value: 24 },
      { name: '24.5g', value: 24.5 },
      { name: '25g', value: 25 },
    ],
    checked: false,
  },
  {
    _id: 7,
    name: '25-30grams',
    options: [
      { name: '25.5g', value: 25.5 },
      { name: '26g', value: 26 },
      { name: '26.5g', value: 26.5 },
      { name: '27g', value: 27 },
      { name: '27.5g', value: 27.5 },
      { name: '28g', value: 28 },
      { name: '28.5g', value: 28.5 },
      { name: '29g', value: 29 },
      { name: '29.5g', value: 29.5 },
      { name: '30g', value: 30 },
    ],
    checked: false,
  },
  {
    _id: 8,
    name: '30-35grams',
    options: [
      { name: '30.5g', value: 30.5 },
      { name: '31g', value: 31 },
      { name: '31.5g', value: 31.5 },
      { name: '32g', value: 32 },
      { name: '32.5g', value: 32.5 },
      { name: '33g', value: 33 },
      { name: '33.5g', value: 33.5 },
      { name: '34g', value: 34 },
      { name: '34.5g', value: 34.5 },
      { name: '35g', value: 35 },
    ],
    checked: false,
  },
  {
    _id: 9,
    name: '35-40grams',
    options: [
      { name: '35.5g', value: 35.5 },
      { name: '36g', value: 36 },
      { name: '36.5g', value: 36.5 },
      { name: '37g', value: 37 },
      { name: '37.5g', value: 37.5 },
      { name: '38g', value: 38 },
      { name: '38.5g', value: 38.5 },
      { name: '39g', value: 39 },
      { name: '39.5g', value: 39.5 },
      { name: '40g', value: 40 },
    ],
    checked: false,
  },
]

const ProductsListing = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { mainCategory, subCategory } = useParams()
  // const [sortBy, setSortBy] = useState('')
  const [accordion, setAccordion] = useState({
    category: true,
    price: false,
    ocassion: false,
    // purity: false,
    weightRange: false,
    gender: false,
    mainCategoryFilter: true,
    subCategoryFilter: true,
    productStyle: true,
  })
  // const [price, setPrice] = useState([1000, 80000])
  const [mainCategoryOptions, setMainCategoryOptions] = useState([])
  const [subCategoryOptions, setSubCategoryOptions] = useState([])
  const [ocassionFilterOptions, setOcassionFilterOptions] = useState([])
  const [purityFilterOptions, setPurityFilterOptions] = useState([])
  const [weightFilterOptions, setWeightFilterOptions] = useState(
    weightRangeOptionsData
  )
  const [genderFilterOptions, setGenderFilterOptions] = useState([])
  const [productStyleOptions, setProductStyleOptions] = useState([])
  const [params, setParams] = useState({
    category_id: '',
    subCategory_id: '',
    occasion: '',
    // purity: '',
    weightRange: '',
    gender: '',
    productstyle: '',
    // page: 1,
    // limit: 10,
  })
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    limit: 12,
  })
  const [productsList, setProductsList] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalProducts, setTotalProducts] = useState(0)
  const [pageQuery, setPageQuery] = useUrlSearchParams(
    {
      ocassion: '',
      // purity: '',
      weight: '',
      gender: '',
      productStyle: '',
      page: 1,
      // search: '',
    },
    {
      ocassion: String,
      // purity: String,
      weight: String,
      gender: String,
      productStyle: String,
      page: Number,
      // search: String,
    }
  )
  const { ocassion, weight, gender, productStyle, page, search } = pageQuery
  const [searchOptions, setSearchOptions] = useState(searchOptionsList)
  // const [search, setSearch] = useState(null)
  const [searchInput, setSearchInput] = useState('')
  const [searchParams, setSearchParams] = useState({
    search: null,
    page: 1,
    limit: 10,
  })

  const isLoading = useRef(true);


  // Handle Sort By filter onchange
  // const handleSortBy = (e) => {
  //   setSortBy(e.target.value)
  // }

  // Handle Price range filter onchange
  // const priceHandleChange = (e, price) => {
  //   setPrice(price)
  // }

  // Handle Ocassion filter onchange
  const handleOcassionFilter = (id, checkedState) => {
    const updatedArray = ocassionFilterOptions?.map((data) =>
      data?._id === id ? { ...data, checked: !checkedState } : { ...data }
    )
    setOcassionFilterOptions(updatedArray)
    // Set Page Query
    const checkedArr = updatedArray?.filter((data) => data?.checked === true)
    const checkedArrValue = checkedArr?.map((data) => data?.name)?.toString()
    setPageQuery({ ...pageQuery, ocassion: checkedArrValue })
  }

  // Handle Purity filter onchange
  // const handlePurityFilter = (id, checkedState) => {
  //   const updatedArray = purityFilterOptions?.map((data) =>
  //     data?._id === id ? { ...data, checked: !checkedState } : { ...data }
  //   )
  //   setPurityFilterOptions(updatedArray)
  //   // Set Page Query
  //   const checkedArr = updatedArray?.filter((data) => data?.checked === true)
  //   const checkedArrValue = checkedArr
  //     ?.map((data) => data?.puritytype)
  //     ?.toString()
  //   setPageQuery({ ...pageQuery, purity: checkedArrValue })
  // }

  // Handle Weight range filter onchange

  const handleWeightRangeFilter = (id, checkedState) => {
    const updatedArray = weightFilterOptions?.map((data) =>
      data?._id === id ? { ...data, checked: !checkedState } : { ...data }
    )
    setWeightFilterOptions(updatedArray)
    // Set Page Query
    const checkedArr = updatedArray?.filter((data) => data?.checked === true)
    const checkedArrValue = checkedArr?.map((data) => data?.name)?.toString()
    setPageQuery({ ...pageQuery, weight: checkedArrValue })
  }

  // Handle Gender filter onchange
  const handleGenderFilter = (id, checkedState) => {
    const updatedArray = genderFilterOptions?.map((data) =>
      data?._id === id ? { ...data, checked: !checkedState } : { ...data }
    )
    setGenderFilterOptions(updatedArray)
    // Set Page Query
    const checkedArr = updatedArray?.filter((data) => data?.checked === true)
    const checkedArrValue = checkedArr
      ?.map((data) => data?.gendername)
      ?.toString()
    setPageQuery({ ...pageQuery, gender: checkedArrValue })
  }

  // Handle product style filter onchange
  const handleProductStyle = (id, checkedState) => {
    const updatedArray = productStyleOptions?.map((data) =>
      data?._id === id ? { ...data, checked: !checkedState } : { ...data }
    )
    setProductStyleOptions(updatedArray)
    // Set Page Query
    const checkedArr = updatedArray?.filter((data) => data?.checked === true)
    const checkedArrValue = checkedArr?.map((data) => data?.name)?.toString()
    setPageQuery({ ...pageQuery, productStyle: checkedArrValue })
  }

  const resetFilters = () => {
    // setParams({
    //   category_id: '',
    //   subcategoryid: '',
    //   ocassion: '',
    //   purity: '',
    //   weight: '',
    //   gender: '',
    // })
    // setPageQuery({
    //   ocassion: '',
    //   purity: '',
    //   weight: '',
    //   gender: '',
    //   productStyle: '',
    // })
    // getProductStyle()
    // getOcassionOptions()
    // getPurityOptions()
    // getWeightRangeFilter()
    // getGenderFilter()
  }

  // Handle pagination
  const handlePagination = (event, value) => {
    if (typeof value === 'number') {
      setCurrentPage(value)
      setPageQuery({ ...pageQuery, page: value })
    }
  }

  //Get main category options api
  const getMainCategory = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setMainCategoryOptions(res?.data?.data?.results)
      } else {
        setMainCategoryOptions([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get main category options Api', err)
    }
    productsApi.getMainCategory().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getMainCategory()
  }, [getMainCategory])

  //Get sub category options api
  const getSubCategory = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setSubCategoryOptions(res?.data?.data)
      } else {
        setSubCategoryOptions([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get sub category options Api', err)
    }
    !_.isEmpty(params?.category_id) &&
      productsApi.getSubCategory(params?.category_id).then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.category_id])
  useEffect(() => {
    getSubCategory()
  }, [getSubCategory])

  //Get product style options based on sub category of metal api
  const getProductStyle = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        // Set the filter based on url query params or set the api results
        const productStyleQuery = productStyle?.split(',')
        if (!_.isEmpty(productStyle) && !_.isEmpty(productStyleQuery)) {
          const tempArr = res?.data?.data?.results?.map((data) => {
            const matchingQuery = productStyleQuery?.find(
              (item) => item === data?.name
            )
            if (matchingQuery === data?.name) {
              return { ...data, checked: true }
            } else {
              return { ...data, checked: false }
            }
          })

          setProductStyleOptions(tempArr)
        } else {
          const addCheckedKeyArr = res?.data?.data?.results?.map((data) => ({
            ...data,
            checked: false,
          }))
          setProductStyleOptions(addCheckedKeyArr)
        }
      } else {
        setProductStyleOptions([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get product style options Api', err)
    }
    !_.isEmpty(params?.subCategory_id) &&
      productsApi
        .getProductStyle(
          !_.isEmpty(params?.subCategory_id) ? params?.subCategory_id : ''
        )
        .then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.subCategory_id])
  useEffect(() => {
    getProductStyle()
  }, [getProductStyle, params?.subCategory_id])

  //Get ocassion filter options options api
  const getOcassionOptions = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        // Set the filter based on url query params or set the api results
        const ocassionQuery = ocassion?.split(',')
        if (!_.isEmpty(ocassion) && !_.isEmpty(ocassionQuery)) {
          const tempArr = res?.data?.data?.results?.map((data) => {
            const matchingQuery = ocassionQuery?.find(
              (item) => item === data?.name
            )
            if (matchingQuery === data?.name) {
              return { ...data, checked: true }
            } else {
              return { ...data, checked: false }
            }
          })

          setOcassionFilterOptions(tempArr)
        } else {
          const addCheckedKeyArr = res?.data?.data?.results?.map((data) => ({
            ...data,
            checked: false,
          }))
          setOcassionFilterOptions(addCheckedKeyArr)
        }
      } else {
        setOcassionFilterOptions([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get ocassion filter options Api', err)
    }
    productsApi.getOcassionList().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getOcassionOptions()
  }, [getOcassionOptions])

  //Get purity filter options api
  // Right now weight range is static
  // const getPurityOptions = useCallback(() => {
  //   dispatch(showLoader('Loading please wait...'))
  //   const onSuccess = (res) => {
  //     dispatch(hideLoader())
  //     if (res?.data?.status?.toLowerCase() === 'true') {
  //       // Set the filter based on url query params or set the api results
  //       const purityQuery = purity?.split(',')
  //       if (!_.isEmpty(purity) && !_.isEmpty(purityQuery)) {
  //         const tempArr = res?.data?.data?.results?.map((data) => {
  //           const matchingQuery = purityQuery?.find(
  //             (item) => parseInt(item) === data?.puritytype
  //           )
  //           if (parseInt(matchingQuery) === data?.puritytype) {
  //             return { ...data, checked: true }
  //           } else {
  //             return { ...data, checked: false }
  //           }
  //         })
  //         setPurityFilterOptions(tempArr)
  //       } else {
  //         const addCheckedKeyArr = res?.data?.data?.results?.map((data) => ({
  //           ...data,
  //           checked: false,
  //         }))
  //         setPurityFilterOptions(addCheckedKeyArr)
  //       }
  //     } else {
  //       setPurityFilterOptions([])
  //     }
  //   }
  //   const onFailure = (err) => {
  //     dispatch(hideLoader())
  //     console.log('Get purity filter options Api', err)
  //   }
  //   productsApi.getPurityList().then(onSuccess, onFailure)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  // useEffect(() => {
  //   getPurityOptions()
  // }, [getPurityOptions])

  //Get weight range filter options api
  // const getWeightRangeFilter = useCallback(() => {
  //   dispatch(showLoader('Loading please wait...'))
  //   const onSuccess = (res) => {
  //     dispatch(hideLoader())
  //     if (res?.data?.status?.toLowerCase() === 'true') {
  //       // Set the filter based on url query params or set the api results
  //       const weightQuery = weight?.split(',')
  //       if (!_.isEmpty(weight) && !_.isEmpty(weightQuery)) {
  //         const tempArr = res?.data?.data?.results?.map((data) => {
  //           const matchingQuery = weightQuery?.find(
  //             (item) => item === data?.range
  //           )
  //           if (matchingQuery === data?.range) {
  //             return { ...data, checked: true }
  //           } else {
  //             return { ...data, checked: false }
  //           }
  //         })
  //         setWeightFilterOptions(tempArr)
  //       } else {
  //         const addCheckedKeyArr = res?.data?.data?.results?.map((data) => ({
  //           ...data,
  //           checked: false,
  //         }))
  //         setWeightFilterOptions(addCheckedKeyArr)
  //       }
  //     } else {
  //       setWeightFilterOptions([])
  //     }
  //   }
  //   const onFailure = (err) => {
  //     dispatch(hideLoader())
  //     console.log('Get weight range filter options Api', err)
  //   }
  //   productsApi.getWeightRangeList().then(onSuccess, onFailure)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  // useEffect(() => {
  //   getWeightRangeFilter()
  // }, [getWeightRangeFilter])

  //Get gender filter options api
  const getGenderFilter = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        // Set the filter based on url query params or set the api results
        const genderQuery = gender?.split(',')
        if (!_.isEmpty(gender) && !_.isEmpty(genderQuery)) {
          const tempArr = res?.data?.data?.results?.map((data) => {
            const matchingQuery = genderQuery?.find(
              (item) => item === data?.gendername
            )
            if (matchingQuery === data?.gendername) {
              return { ...data, checked: true }
            } else {
              return { ...data, checked: false }
            }
          })

          setGenderFilterOptions(tempArr)
        } else {
          const addCheckedKeyArr = res?.data?.data?.results?.map((data) => ({
            ...data,
            checked: false,
          }))
          setGenderFilterOptions(addCheckedKeyArr)
        }
      } else {
        setGenderFilterOptions([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get gender filter options Api', err)
    }
    productsApi.getGenderList().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getGenderFilter()
  }, [getGenderFilter])

  // Handle get products list with filters
  const getProductsList = useCallback((abortController) => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        setProductsList(res?.data?.data)
        setTotalProducts(res?.data?.pagination?.totalResults || 0)
      } else {
        setProductsList([])
      }
      isLoading.current = false;
      !isLoading.current && dispatch(hideLoader())
    }
    const onFailure = (err) => {
      console.log('Get products list Api', err)
    }

    productsApi
      .getProductsList(
        _.pickBy( 
          params,
          (value) =>
            value != null && value !== '' && value !== undefined && value !== []
        ),
        paginationParams,
        abortController.signal, // Associate the signal with the request
      )
      .then(onSuccess, onFailure).finally(() => dispatch(hideLoader()))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  useEffect(() => {
    let abortController;
    abortController = new AbortController();
    getProductsList(abortController);

    // Cleanup function to cancel the request when the component unmounts
    return () => {
      console.error("cancelled");
      abortController.abort();
    };
  }, [getProductsList, params, paginationParams])

  // Handle search handle change
  // const handleSearchOnChange = _.debounce(
  //   (e) => {
  //     // setPaginationParams((prevState) => ({ ...prevState, page: 1 }))
  //     setSearchParams((prevState) => ({
  //       ...prevState,
  //       search: e?.target?.value,
  //     }))
  //     setPageQuery({ ...pageQuery, search: e?.target?.value })
  //   },
  //   [700]
  // )

  // Set Search page query on page query change
  // useEffect(() => {
  //   setSearchInput(search)
  // }, [])

  // handle products search
  const handleProductsSearch = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setProductsList(res?.data?.data)
        setTotalProducts(res?.data?.totalItems || 0)
      } else {
        setProductsList([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get products list from search Api', err)
    }
    productsApi
      .searchProducts({ search: searchInput }, paginationParams)
      .then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput, paginationParams])
  useEffect(() => {
    searchInput?.length > 2 && handleProductsSearch()
  }, [handleProductsSearch, searchInput, paginationParams])

  // Set Params based on url path and filters onchange
  useEffect(() => {
    const findMainCategory = mainCategoryOptions.find(
      (data) => data?.name?.toLowerCase() === mainCategory?.toLowerCase()
    )
    const findSubCategory = subCategoryOptions.find(
      (data) => data?.name?.toLowerCase() === subCategory?.toLowerCase()
    )
    const selectedOcassion = ocassionFilterOptions.filter(
      (data) => data?.checked === true
    )
    const selectedPurity = purityFilterOptions.filter(
      (data) => data?.checked === true
    )
    const selectedWeightRange = weightFilterOptions.filter(
      (data) => data?.checked === true
    )
    const selectedGender = genderFilterOptions.filter(
      (data) => data?.checked === true
    )
    const selectedProductStyle = productStyleOptions.filter(
      (data) => data?.checked === true
    )
    setParams((prevState) => ({
      ...prevState,
      category_id: findMainCategory?._id || '',
      subCategory_id: findSubCategory?._id || '',
      occasion: selectedOcassion?.map((data) => data?._id).toString(),
      // purity: selectedPurity?.map((data) => data?._id).toString(),
      weightRange: selectedWeightRange?.map((data) => data?._id).toString(),
      gender: selectedGender?.map((data) => data?._id).toString(),
      productstyle: selectedProductStyle?.map((data) => data?._id).toString(),
      // page: page || 1,
    }))
    setPaginationParams((prevState) => ({ ...prevState, page: page || 1 }))
    setCurrentPage(page || 1)
  }, [
    mainCategory,
    subCategory,
    mainCategoryOptions,
    subCategoryOptions,
    ocassionFilterOptions,
    purityFilterOptions,
    weightFilterOptions,
    genderFilterOptions,
    productStyleOptions,
    page,
  ])

  return (
    <>
      <Grid container className={classes.root}>
        {/* Breadcrumbs */}
        <Grid item xs={12}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            {subCategory ? (
              <Link
                underline="hover"
                color="inherit"
                href={`/shop/${mainCategory}`}
                style={{ textTransform: 'capitalize' }}
              >
                {mainCategory}
              </Link>
            ) : (
              <Typography
                variant="body1"
                style={{ textTransform: 'capitalize' }}
              >
                {mainCategory}
              </Typography>
            )}
            {subCategory && (
              <Typography
                variant="body1"
                style={{ textTransform: 'capitalize' }}
              >
                {subCategory}
              </Typography>
            )}
          </Breadcrumbs>
        </Grid>
        {/* Title */}
        {/* <Grid item xs={12} className={classes.titleWrapper}> */}
        {/* <div className={classes.title}>
            <Typography variant="h5">
              Jewellery | {productsList?.length} Designs
            </Typography>
          </div> */}
        {/* <div className={classes.clearAll}>
            <Typography variant="h5" onClick={resetFilters}>
              Clear All
            </Typography>
          </div> */}
        {/* </Grid> */}
        <Grid item xs={12} className={classes.searchWrapper}>
          {/* <Grid item xs={12} sm={6} md={5} lg={4} xl={3}>
            <TextField
              // {...params}
              name="searchInput"
              id="searchInput"
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e?.target?.value)
                handleSearchOnChange(e)
              }}
              type={'text'}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Search for jewels and more..."
              color="secondary"
              InputProps={{
                ...params.InputProps,
                endAdornment: <SearchIcon />,
              }}
            />
          </Grid> */}
          <div className={classes.title}>
            <Typography variant="h5">
              {mainCategory} | {subCategory && `${subCategory} | `}{' '}
              {productsList?.length} Designs
            </Typography>
          </div>
        </Grid>

        {/* Sort Filter */}
        {/* <Grid item xs={12} className={classes.sortByWrapper}>
          <section className={classes.sortByLabel}>
            <Typography variant="body1">Shop By</Typography>
          </section>
          <section className={classes.sortByFilter}>
            <FormControl fullWidth size="small">
              <InputLabel id="sort-by-label">Sort by</InputLabel>
              <Select
                labelId="sort-by-label"
                id="sort-by-select"
                value={sortBy}
                label="Sort by"
                onChange={handleSortBy}
              >
                <MenuItem value={'lowtohigh'}>Price : Low to High</MenuItem>
                <MenuItem value={'hightolow'}>Price : High to Low</MenuItem>
              </Select>
            </FormControl>
          </section>
        </Grid> */}
        {/* Filters && Products */}
        <Grid item xs={12} className={classes.wrapper}>
          <Grid item xs={12} sm={3} lg={2.5} className={classes.filterWrapper}>
            {/* Category Filter */}
            {/* <Accordion
              expanded={accordion?.category}
              onChange={() =>
                setAccordion((prevState) => ({
                  ...prevState,
                  category: !accordion?.category,
                }))
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className={classes.filterHeader}>
                  <Typography variant="body1">Category</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <section className={classes.categoryFilter}>
                  {categoryFilter?.map((data) => (
                    <Typography
                      variant="body1"
                      key={data?.id}
                      style={{ cursor: 'pointer' }}
                    >
                      {data?.name}
                    </Typography>
                  ))}
                </section>
              </AccordionDetails>
            </Accordion> */}
            {/* Price Range Filter */}
            {/* <Accordion
              expanded={accordion?.price}
              onChange={() =>
                setAccordion((prevState) => ({
                  ...prevState,
                  price: !accordion?.price,
                }))
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <div className={classes.filterHeader}>
                  <Typography variant="body1">Price</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <Slider
                  aria-label="Default"
                  valueLabelDisplay="auto"
                  min={1000}
                  max={80000}
                  step={100}
                  value={price}
                  onChange={priceHandleChange}
                />
                <Typography variant="body2">
                  Min : &#x20b9;{price?.[0] || 0} - Max : &#x20b9;
                  {price?.[1] || 0}
                </Typography>
              </AccordionDetails>
            </Accordion> */}

            {/*MainCategory Filter */}
            {mainCategory?.toLowerCase() === 'all' && (
              <Accordion
                expanded={accordion?.mainCategoryFilter}
                onChange={() =>
                  setAccordion((prevState) => ({
                    ...prevState,
                    mainCategoryFilter: !accordion?.mainCategoryFilter,
                  }))
                }
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <div className={classes.filterHeader}>
                    <Typography variant="body1">Metal Types</Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <section className={classes.filterItemWrapper}>
                    {mainCategoryOptions?.map((data) => (
                      <div
                        key={data?._id}
                        className={classes.subCategoryWrapper}
                      >
                        <Typography
                          variant="body1"
                          onClick={() => {
                            navigate(`/shop/${data?.name?.toLowerCase()}`)
                          }}
                        >
                          {data?.name}
                        </Typography>
                      </div>
                    ))}
                  </section>
                </AccordionDetails>
              </Accordion>
            )}

            {/*SubCategory Filter */}
            {mainCategory?.toLowerCase() !== 'all' &&
              _.isEmpty(subCategory) && (
                <Accordion
                  expanded={accordion?.subCategoryFilter}
                  onChange={() =>
                    setAccordion((prevState) => ({
                      ...prevState,
                      subCategoryFilter: !accordion?.subCategoryFilter,
                    }))
                  }
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <div className={classes.filterHeader}>
                      <Typography variant="body1">Sub Products</Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <section className={classes.filterItemWrapper}>
                      {subCategoryOptions?.map((data) => (
                        <div
                          key={data?._id}
                          className={classes.subCategoryWrapper}
                        >
                          <Typography
                            variant="body1"
                            onClick={() =>
                              navigate(
                                `/shop/${mainCategory}/${data?.name?.toLowerCase()}`
                              )
                            }
                          >
                            {data?.name}
                          </Typography>
                        </div>
                      ))}
                    </section>
                  </AccordionDetails>
                </Accordion>
              )}

            {/*Product style Filter */}
            {_.isEmpty(subCategory) ? (
              <></>
            ) : (
              !_.isEmpty(productStyleOptions) && (
                <Accordion
                  expanded={accordion?.productStyle}
                  onChange={() =>
                    setAccordion((prevState) => ({
                      ...prevState,
                      productStyle: !accordion?.productStyle,
                    }))
                  }
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <div className={classes.filterHeader}>
                      <Typography variant="body1">Product Style</Typography>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <section className={classes.filterItemWrapper}>
                      {productStyleOptions?.map((data) => (
                        <FormControlLabel
                          key={data?.id}
                          control={
                            <Checkbox
                              name={data?.name}
                              id={data?._id}
                              checked={data?.checked}
                              onChange={() =>
                                handleProductStyle(data?._id, data?.checked)
                              }
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                          }
                          label={data?.name}
                        />
                      ))}
                    </section>
                  </AccordionDetails>
                </Accordion>
              )
            )}

            {/* Ocassion Filter */}
            <Accordion
              expanded={accordion?.ocassion}
              onChange={() =>
                setAccordion((prevState) => ({
                  ...prevState,
                  ocassion: !accordion?.ocassion,
                }))
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <div className={classes.filterHeader}>
                  <Typography variant="body1">Occasion</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <section className={classes.filterItemWrapper}>
                  {ocassionFilterOptions?.map((data) => (
                    <FormControlLabel
                      key={data?.id}
                      control={
                        <Checkbox
                          name={data?.name}
                          id={data?._id}
                          checked={data?.checked}
                          onChange={() =>
                            handleOcassionFilter(data?._id, data?.checked)
                          }
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      }
                      label={data?.name}
                    />
                  ))}
                </section>
              </AccordionDetails>
            </Accordion>

            {/* Purity Filter */}
            {/* <Accordion
              expanded={accordion?.purity}
              onChange={() =>
                setAccordion((prevState) => ({
                  ...prevState,
                  purity: !accordion?.purity,
                }))
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <div className={classes.filterHeader}>
                  <Typography variant="body1">Purity</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <section className={classes.filterItemWrapper}>
                  {purityFilterOptions?.map((data) => (
                    <FormControlLabel
                      key={data?.id}
                      control={
                        <Checkbox
                          name={data?.puritytype}
                          id={data?._id}
                          checked={data?.checked}
                          onChange={() =>
                            handlePurityFilter(data?._id, data?.checked)
                          }
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      }
                      label={`${data?.puritytype} kt`}
                    />
                  ))}
                </section>
              </AccordionDetails>
            </Accordion> */}

            {/* Weight Range Filter */}
            <Accordion
              expanded={accordion?.weightRange}
              onChange={() =>
                setAccordion((prevState) => ({
                  ...prevState,
                  weightRange: !accordion?.weightRange,
                }))
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <div className={classes.filterHeader}>
                  <Typography variant="body1">Weight Range</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <section className={classes.filterItemWrapper}>
                  {weightFilterOptions?.map((data) => (
                    <FormControlLabel
                      key={data?.id}
                      control={
                        <Checkbox
                          name={data?.name}
                          id={data?._id}
                          checked={data?.checked}
                          onChange={() =>
                            handleWeightRangeFilter(data?._id, data?.checked)
                          }
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      }
                      label={data?.name}
                    />
                  ))}
                </section>
              </AccordionDetails>
            </Accordion>

            {/*Gender Filter */}
            <Accordion
              expanded={accordion?.gender}
              onChange={() =>
                setAccordion((prevState) => ({
                  ...prevState,
                  gender: !accordion?.gender,
                }))
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
              >
                <div className={classes.filterHeader}>
                  <Typography variant="body1">Gender</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <section className={classes.filterItemWrapper}>
                  {genderFilterOptions?.map((data) => (
                    <FormControlLabel
                      key={data?.id}
                      control={
                        <Checkbox
                          name={data?.gendername}
                          id={data?._id}
                          checked={data?.checked}
                          onChange={() =>
                            handleGenderFilter(data?._id, data?.checked)
                          }
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      }
                      label={data?.gendername}
                    />
                  ))}
                </section>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid
            item
            xs={12}
            sm={9}
            lg={9.5}
            className={classes.productsContainer}
          >
            {!_.isEmpty(productsList) ? (
              <>
                <Grid item xs={12} className={classes.productsWrapper}>
                  {productsList?.map((data) => (
                    <Grid
                      item
                      xs={6}
                      sm={6}
                      lg={3}
                      className={classes.productSpacing}
                      key={data?.id}
                    >
                      <section
                        className={classes.productCard}
                        onClick={() => navigate(`/product/${data?.productid}`)}
                      >
                        <div className={classes.imgWrapper}>
                          <img
                            src={
                              API_ENDPOINTS.FILE_URL +
                              data?.image?.[0]?.filename
                            }
                            alt={data?.title}
                            className={classes.productImg}
                          />{' '}
                        </div>
                        <div className={classes.productDetail}> 
                            
                            {data?.product_stylename === data?.name || !data?.product_stylename ? null : data?.product_stylename }
                            <div><strong>
                              {data?.name || data?.product_stylename}
                              {/* &#x20b9; {numberToIndianRupee(data?.price)} */}
                            </strong></div>
                            {/* {data?.metalDiscount !== 0 && (
                          <span className={classes.discount}>
                            ({data?.metalDiscount}% OFF)
                          </span>
                        )} */}
                        </div>
                      </section>
                    </Grid>
                  ))}
                </Grid>
                {/* Pagination */}
                {totalProducts < 11 ? (
                  <></>
                ) : (
                  <Grid item xs={12} className={classes.pagination}>
                    <section>
                      <Typography variant="body1">
                        Page {currentPage} of{' '}
                        {Math.ceil(totalProducts / paginationParams.limit)}
                      </Typography>
                    </section>
                    <Pagination
                      count={Math.ceil(totalProducts / paginationParams.limit)}
                      page={currentPage}
                      onChange={handlePagination}
                      color="secondary"
                      shape="rounded"
                    />
                  </Grid>
                )}
              </>
            ) : (
              <>
                <section className={classes.noDataWrapper}>
                  {isLoading.current ? null : (
                    <img
                      src="/assets/images/notfound1.png"
                      alt="No data"
                      className={classes.notFoundImg}
                    />
                  )}
                  <Typography variant="h6">
                    {isLoading.current
                      ? `Loading...`
                      : <>We can't find products matching the selection <br /> Try
                    different filters !</>}
                  </Typography>
                </section>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default ProductsListing
